<template>
  <div class="html-renderer" v-html="html"></div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HtmlRenderer extends Vue {
  @Prop({ required: true, type: String })
  public html!: string;
}
</script>

<style lang="scss" scoped>
.html-renderer {
  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    font-weight: bold;
    line-height: 1.3em;
    margin: 1.5em 0 0.5em 0;

    &:first-child {
      margin-top: 0;
    }
  }

  :deep(h1) {
    font-size: 2em;
  }

  :deep(h2) {
    font-size: 1.5em;
  }

  :deep(h3) {
    font-size: 1.25em;
  }

  :deep(h4) {
    font-size: 1.1em;
  }

  :deep(h5),
  :deep(h6) {
    font-size: 1em;
  }

  :deep(p) {
    line-height: 1.6em;
    margin: 0.8em 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(ul) {
    line-height: 1.6em;
    margin: 0.8em 0;
    padding-left: 2em;
    list-style-type: disc;
    list-style-position: outside;
  }

  :deep(ol) {
    line-height: 1.6em;
    margin: 0.8em 0;
    padding-left: 2em;
    list-style-type: decimal;
    list-style-position: outside;
  }

  :deep(li) {
    margin: 0.4em 0;
    display: list-item;
  }

  :deep(a) {
    color: $color-theme-red;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  :deep(strong),
  :deep(b) {
    font-weight: bold;
  }

  :deep(strong) {
    color: $color-theme-red;
  }

  :deep(em),
  :deep(i) {
    font-style: italic;
  }

  :deep(blockquote) {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 3px solid $color-theme-yellow;
    opacity: 0.9;
  }

  :deep(code) {
    font-family: monospace;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.2em 0.4em;
    border-radius: 3px;
  }

  :deep(pre) {
    margin: 1em 0;
    padding: 1em;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
    }
  }

  :deep(hr) {
    margin: 2em 0;
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  :deep(table) {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
  }

  :deep(th),
  :deep(td) {
    padding: 0.5em;
    border: 1px solid rgba(255, 255, 255, 0.2);
    text-align: left;
  }

  :deep(th) {
    font-weight: bold;
    background: rgba(255, 255, 255, 0.1);
  }

  :deep(img) {
    max-width: 100%;
    height: auto;
    margin: 1em 0;
  }
}
</style>
